import React from 'react';
import {
    Box,
    Container,
    Text,
    Heading,
    SimpleGrid,
    VStack,
    Icon,
    Button,
} from '@chakra-ui/react';
import { FaGlobe, FaMobileAlt, FaChartLine, FaArrowRight } from 'react-icons/fa';
import { TbAugmentedReality } from "react-icons/tb";
import { SiGoogleadsense } from "react-icons/si";
import { MdDesignServices } from "react-icons/md";
import { useNavigate } from 'react-router-dom';

function Services() {
      const navigate = useNavigate();

    const services = [
        {
            id: 1,
            title: 'Website Development',
            icon: FaGlobe,
            description: 'We craft responsive, user-friendly websites tailored to your business needs, ensuring seamless performance, modern design, and optimal functionality across all devices.'
        },
        {
            id: 2,
            title: 'Mobile App Development',
            icon: FaMobileAlt,
            description: 'Our team builds high-performance mobile applications for iOS and Android, delivering intuitive interfaces and robust features to engage your audience on the go.'
        },
        {
            id: 3,
            title: 'AR/VR Development',
            icon: TbAugmentedReality,
            description: 'Immerse your users in cutting-edge augmented and virtual reality experiences, designed to captivate and innovate across industries like gaming, education, and training.'
        },
        {
            id: 4,
            title: 'SEO & Google Ads',
            icon: SiGoogleadsense,
            description: 'Boost your online visibility with strategic SEO and targeted Google Ads campaigns, driving traffic, improving rankings, and maximizing your return on investment.'
        },
        {
            id: 5,
            title: 'Logo & Graphic Design',
            icon: MdDesignServices,
            description: 'Create a lasting impression with custom logos and stunning graphic designs that reflect your brand’s identity and resonate with your target audience.'
        },
        {
            id: 6,
            title: 'Social Media Marketing (Facebook, Instagram)',
            icon: FaChartLine,
            description: 'Engage and grow your audience with tailored social media strategies on platforms like Facebook and Instagram, leveraging compelling content and data-driven campaigns.'
        },
    ];

    return (
        <Box as="section" py={20} id="services">
            <Container maxW="7xl">
                <VStack spacing={4} mb={10} textAlign="center"  data-aos="fade-up">
                    <Text color="gray.500" fontWeight="bold" textTransform="uppercase">
                        Services
                    </Text>
                    <Heading size="2xl">
                        <Text as="span" color="gray.200" display="inline-block" mr={2}>
                            Services
                        </Text>
                        We Offer
                    </Heading>
                    <Text color="gray.500" maxW="600px">
                        Discover our comprehensive range of digital solutions designed to elevate your brand, engage your audience, and drive business growth.
                    </Text>
                    <Button rightIcon={<FaArrowRight />} bg="customBlue.500"
                     transition="all 0.3s ease"
                     border="2px solid transparent"
                     color={'white'}
                     _hover={{
                       bg: 'transparent',
                       color: 'blue.300',
                       border: '2px solid',
                       borderColor: 'blue.400',
                     }}
                      onClick={() => navigate('/services')}
                    >
                        See All Services
                    </Button>
                </VStack>

                <SimpleGrid columns={[1, 2, 3]} spacing={10}>
                    {services.map((service) => (
                        <Box
                            key={service.id}
                            borderWidth="1px"
                            borderRadius="xl"
                            p={8}
                            textAlign="center"
                            transition="0.3s"
                            _hover={{ boxShadow: 'lg', transform: 'scale(1.05)', backgroundColor: 'gray.800' }}
                             data-aos="fade-up"
                        >
                            <VStack spacing={4}>
                                <Icon as={service.icon} boxSize={12} color="customBlue.600" />
                                <Heading size="md">{service.title}</Heading>
                                <Text color="gray.500">
                                    {service.description}
                                </Text>
                                {/* <Button
                                    as="a"
                                    href="service-single.html"
                                    rightIcon={<FaArrowRight />}
                                    // colorScheme="customBlue"
                                     bg="customBlue.600"
                                    variant="ghost"
                                    size="sm"
                                    _hover={{ bg: 'customBlue.500', color: 'white' }}
                                    _active={{ bg: 'customBlue.700' }}
                                >
                                    Read More
                                </Button> */}
                            </VStack>
                        </Box>
                    ))}
                </SimpleGrid>
            </Container>
        </Box>
    );
}

export default Services;